export const types = {
  LOAD_APP: 'LOAD_APP',
  SET_ID_TOKEN: 'SET_ID_TOKEN',

  // CUSTOMER_ACCOUNTS
  SET_CUSTOMER_ACCOUNTS: 'SET_CUSTOMER_ACCOUNTS',
  UNSELECT_CUSTOMER_ACCOUNTS: 'UNSELECT_CUSTOMER_ACCOUNTS',
  UNPICKED_CUSTOMER_ACCOUNTS: 'UNPICKED_CUSTOMER_ACCOUNTS',
  SET_CUSTOMER_ACCOUNT: 'SET_CUSTOMER_ACCOUNT',
  CALCULATE_CART: 'CALCULATE_CART',

  SET_DOMAIN: 'SET_DOMAIN',

  SET_LOADING: 'SET_LOADING',
  SET_DATA: 'SET_DATA',
  SET_PLACES: 'SET_PLACES',
  REFRESH_PLACES: 'REFRESH_PLACES',
  SET_PRICES: 'SET_PRICES',
  SET_SESSION_INFO: 'SET_SESSION_INFO',
  SET_MOVIE_INFO: 'SET_MOVIE_INFO',
  SET_HALLS: 'SET_HALLS',
  SET_THEATRE: 'SET_THEATRE',
  ADD_PLACE_TO_CART: 'ADD_PLACE_TO_CART',
  REMOVE_PLACE_FROM_CART: 'REMOVE_PLACE_FROM_CART',
  ADD_BAR_TO_CART: 'ADD_BAR_TO_CART',
  SET_DONATION_SIZE: 'SET_DONATION_SIZE',
  REMOVE_BAR_FROM_CART: 'REMOVE_BAR_FROM_CART',
  CLEAR_BAR: 'CLEAR_BAR',
  REMOVE_ADDED_CLASS_FROM_BAR: 'REMOVE_ADDED_CLASS_FROM_BAR',
  CHANGE_BAR_IN_CART: 'CHANGE_BAR_IN_CART',
  RESERVE_THICKETS: 'RESERVE_THICKETS',
  SET_TICKET_ORDER_ID: 'SET_TICKET_ORDER_ID',
  SET_LOCAL_ORDER_ID: 'SET_LOCAL_ORDER_ID',
  SET_TRANSACTION_ID: 'SET_TRANSACTION_ID',
  SET_BAR_ORDER_ID: 'SET_BAR_ORDER_ID',
  ADD_ERROR: 'ADD_ERROR',
  CLEAR_ERRORS: 'CLEAR_ERRORS',
  START_COUNTDOWN: 'START_COUNTDOWN',
  SET_PAYMENT_TYPE: 'SET_PAYMENT_TYPE',
  UPDATE_PROP_VALUE: 'UPDATE_PROP_VALUE',
  RESTORE_USER_DATA: 'RESTORE_USER_DATA',
  RESET_SESSION_END_AT: 'RESET_SESSION_END_AT',
  CLEAR_CART: 'CLEAR_CART',
  CLEAR_USER: 'CLEAR_USER',
  SET_USER_DATA: 'SET_USER_DATA',
  SET_USER_BALANCE: 'SET_USER_BALANCE',
  CHANGE_PAYMENT_WITH_BONUSES: 'CHANGE_PAYMENT_WITH_BONUSES',
  GET_TOTAL_SUM: 'GET_TOTAL_SUM',
  CALCULATE_USER_MAX_BONUSES: 'CALCULATE_USER_MAX_BONUSES',

  //socket events
  SOCKET_CONNECT: 'SOCKET_CONNECT',
  SOCKET_USER_SESSION_ID: 'SOCKET_USER_SESSION_ID',
  SOCKET_DISCONNECTING: 'SOCKET_DISCONNECTING',
  SOCKET_DISCONNECT: 'SOCKET_DISCONNECT',
};
